<template>
  <div class="search-content">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'CashaccountLayout',
    data () {
      return {
        tabs: {
          items: [
            {
              key: '1',
              title: '现金账户'
            },
            {
              key: '2',
              title: '提现申请'
            }
          ],
          active: () => {
            switch (this.$route.path) {
              case '/cashaccount/cashaccount-list':
                return '1'
              case '/cashaccount/withdraw-list':
                return '2'
              default:
                return '1'
            }
          },
          callback: (key) => {
            switch (key) {
              case '1':
                this.$router.push('/cashaccount/cashaccount-list')
                break
              case '2':
                this.$router.push('/cashaccount/withdraw-list')
                break
              default:
                this.$router.push('/workplace')
            }
          }
        },
        search: false
      }
    },
    computed: {

    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .search-head{
    background-color: #fff;
    margin: -25px -24px -24px;
    .search-input{
      text-align: center;
      margin-bottom: 16px;
    }
  }
  .search-content{
    margin-top: 0px;
  }
</style>